<template lang="pug">
.upload-image
  shFormUpload(title="Upload Images")
</template>

<script>
import shFormUpload from '@/components/pages/image/FormUpload'

export default {
  name: 'UploadImage',

  components: { shFormUpload }
}
</script>

<style lang="stylus">
.upload-image
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/image/Upload.vue